import parse from 'html-react-parser'
import React from 'react'
import { useLoaderData, useNavigate } from 'react-router'
import { useSearchParams } from 'react-router-dom'
import { formatDate, type PrintLoaderData } from './shared'
import * as S from './styles'
export function Page() {
  const { auditData } = useLoaderData() as PrintLoaderData
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  const printOptions = {
    viewCheckPoints: searchParams.get('viewCheckPoints') === 'true',
    viewSummary: searchParams.get('viewSummary') === 'true',
    viewPerspectives: searchParams.get('viewPerspectives') === 'true'
  }

  const renderPledges = () => {
    return (
      <S.PledgesTable>
        <tbody>
          {auditData.pledges.map(pledge => (
            <>
              <S.PledgeSpacerRow>
                <S.PledgeSpacerCell width='15px'>&nbsp;</S.PledgeSpacerCell>
                <S.PledgeSpacerCell width='585px'>&nbsp;</S.PledgeSpacerCell>
              </S.PledgeSpacerRow>
              <S.PledgeHeaderRow key={pledge.id}>
                <S.PledgeHeaderCell colSpan={2}>
                  <S.PledgeInnerTable cellPadding={0} cellSpacing={0}>
                    <tbody>
                      <tr>
                        <S.PledgeNumberCell>
                          {pledge.pledgeNo}
                        </S.PledgeNumberCell>
                        <S.PledgeDescriptionCell
                          className='pledge'
                          style={{
                            border: '1px solid #000',
                            borderLeft: 'none'
                          }}
                        >
                          {parse(pledge.translatedDescription)}
                        </S.PledgeDescriptionCell>
                      </tr>
                    </tbody>
                  </S.PledgeInnerTable>
                </S.PledgeHeaderCell>
              </S.PledgeHeaderRow>

              {pledge.note && (
                <S.PledgeNoteRow>
                  <S.PledgeNoteCell colSpan={2}>
                    <S.PledgeNoteHeaderSpan>
                      Pledge Comment
                    </S.PledgeNoteHeaderSpan>
                    <br />
                    <S.PledgeNoteContentSpan>
                      {pledge.note}
                    </S.PledgeNoteContentSpan>
                  </S.PledgeNoteCell>
                </S.PledgeNoteRow>
              )}

              {printOptions.viewPerspectives && (
                <>
                  <S.PerspectiveRow>
                    <S.PledgeSpacerCell width='15px' />
                    <S.PerspectiveCell>
                      <S.PerspectiveTable cellPadding={0} cellSpacing={0}>
                        <tbody>
                          <tr>
                            <S.PerspectiveHeaderCell>
                              Customer Perspective
                            </S.PerspectiveHeaderCell>
                          </tr>
                          <tr>
                            <S.PerspectiveContentCell>
                              {parse(pledge.customerPerspective)}
                            </S.PerspectiveContentCell>
                          </tr>
                        </tbody>
                      </S.PerspectiveTable>
                    </S.PerspectiveCell>
                  </S.PerspectiveRow>

                  <S.PerspectiveRow>
                    <S.PledgeSpacerCell width='15px' />
                    <S.PerspectiveCell>
                      <S.PerspectiveTable cellPadding={0} cellSpacing={0}>
                        <tbody>
                          <tr>
                            <S.PerspectiveHeaderCell>
                              Dealer Perspective
                            </S.PerspectiveHeaderCell>
                          </tr>
                          <tr>
                            <S.PerspectiveContentCell>
                              {parse(pledge.dealerPerspective)}
                            </S.PerspectiveContentCell>
                          </tr>
                        </tbody>
                      </S.PerspectiveTable>
                    </S.PerspectiveCell>
                  </S.PerspectiveRow>
                </>
              )}
              <S.PledgeSpacerRow>
                <S.PledgeSpacerCell width='15px'>&nbsp;</S.PledgeSpacerCell>
                <S.PledgeSpacerCell width='585px'>&nbsp;</S.PledgeSpacerCell>
              </S.PledgeSpacerRow>
              <tr>
                <td style={{ width: '9px' }}></td>
                <S.AuditPointsHeaderCell colSpan={2}>
                  <S.AuditPointsHeaderTable cellPadding={0} cellSpacing={0}>
                    <tbody>
                      <S.AuditPointsHeaderRow>
                        <S.HeaderColumnCell
                          style={{ padding: 0 }}
                          width='439px'
                        ></S.HeaderColumnCell>
                        <S.HeaderColumnCell style={{ padding: 0 }} width='43px'>
                          Yes
                        </S.HeaderColumnCell>
                        <S.HeaderColumnCell style={{ padding: 0 }} width='43px'>
                          No
                        </S.HeaderColumnCell>
                        <S.HeaderColumnCell style={{ padding: 0 }} width='60px'>
                          Reference Documents
                        </S.HeaderColumnCell>
                      </S.AuditPointsHeaderRow>
                    </tbody>
                  </S.AuditPointsHeaderTable>
                  {pledge.auditPoints.map(auditPoint => (
                    <React.Fragment key={auditPoint.id}>
                      <S.AuditPointRow>
                        <S.AuditPointNumberCell />
                        <S.AuditPointContentCell
                          isMandatory={auditPoint.isMandatory}
                        >
                          <S.AuditPointTable cellPadding={0} cellSpacing={0}>
                            <tbody>
                              <tr>
                                <S.AuditPointDescriptionCell
                                  className={
                                    auditPoint.isMandatory
                                      ? 'mandatoryAuditPoint'
                                      : 'developmentAuditPoint'
                                  }
                                >
                                  {auditPoint.auditPointNo}{' '}
                                  {parse(auditPoint.translatedDescription)}
                                </S.AuditPointDescriptionCell>
                                <S.CheckboxCell>
                                  {auditPoint.isPointCheckedYes === true ? (
                                    <S.CheckboxImage
                                      src='/assets/checkbox_on.png'
                                      alt='Checked'
                                    />
                                  ) : (
                                    <S.CheckboxImage
                                      src='/assets/checkbox_off.png'
                                      alt='Not checked'
                                    />
                                  )}
                                </S.CheckboxCell>
                                <S.CheckboxCell>
                                  {auditPoint.isPointCheckedYes === false ? (
                                    <S.CheckboxImage
                                      src='/assets/checkbox_on.png'
                                      alt='Checked'
                                    />
                                  ) : (
                                    <S.CheckboxImage
                                      src='/assets/checkbox_off.png'
                                      alt='Not checked'
                                    />
                                  )}
                                </S.CheckboxCell>
                                <S.DocumentsCell>
                                  {auditPoint.hasReferenceDocuments && (
                                    <S.InfoImage
                                      src='/assets/info.gif'
                                      alt='Reference Documents'
                                    />
                                  )}
                                </S.DocumentsCell>
                              </tr>
                            </tbody>
                          </S.AuditPointTable>
                        </S.AuditPointContentCell>
                      </S.AuditPointRow>

                      {printOptions.viewCheckPoints &&
                        auditPoint.checkPoints.map(checkPoint => (
                          <S.CheckPointRow key={checkPoint.id}>
                            <S.CheckPointSpacerCell></S.CheckPointSpacerCell>
                            <S.CheckPointContentCell
                              isMandatory={auditPoint.isMandatory ?? false}
                            >
                              <S.CheckPointTable
                                cellPadding={0}
                                cellSpacing={0}
                              >
                                <tbody>
                                  <tr>
                                    <S.CheckPointSpacerTableCell></S.CheckPointSpacerTableCell>
                                    <S.CheckPointDescriptionCell
                                      className={
                                        auditPoint.isMandatory
                                          ? 'mandatoryCheckPoint'
                                          : 'developmentCheckPoint'
                                      }
                                    >
                                      {checkPoint.checkPointNo}{' '}
                                      {parse(checkPoint.translatedDescription)}
                                    </S.CheckPointDescriptionCell>
                                    <S.CheckPointCheckboxCell>
                                      {checkPoint.isPointCheckedYes === true ? (
                                        <S.CheckboxImage
                                          src='/assets/checkbox_on.png'
                                          alt='Checked'
                                        />
                                      ) : (
                                        <S.CheckboxImage
                                          src='/assets/checkbox_off.png'
                                          alt='Not checked'
                                        />
                                      )}
                                    </S.CheckPointCheckboxCell>
                                    <S.CheckPointCheckboxCell>
                                      {checkPoint.isPointCheckedYes ===
                                      false ? (
                                        <S.CheckboxImage
                                          src='/assets/checkbox_on.png'
                                          alt='Checked'
                                        />
                                      ) : (
                                        <S.CheckboxImage
                                          src='/assets/checkbox_off.png'
                                          alt='Not checked'
                                        />
                                      )}
                                    </S.CheckPointCheckboxCell>
                                    <S.CheckPointDocumentsCell></S.CheckPointDocumentsCell>
                                  </tr>
                                </tbody>
                              </S.CheckPointTable>
                            </S.CheckPointContentCell>
                          </S.CheckPointRow>
                        ))}
                    </React.Fragment>
                  ))}
                </S.AuditPointsHeaderCell>
              </tr>

              {pledge.auditPoints.filter(ap => ap.note != null).length > 0 && (
                <S.NotesRow>
                  <S.PledgeSpacerCell width='15px' />
                  <S.NotesCell>
                    <S.NotesTable cellPadding={2} cellSpacing={0}>
                      <tbody>
                        <tr>
                          <S.NotesHeaderCell width='100px'>
                            {'Audit Point'}
                          </S.NotesHeaderCell>
                          <S.NotesHeaderCell width='485px'>
                            {'Note'}
                          </S.NotesHeaderCell>
                        </tr>
                        {pledge.auditPoints
                          .filter(ap => ap.note != null)
                          .map(auditPoint => (
                            <tr
                              key={auditPoint.id}
                              style={{ verticalAlign: 'top' }}
                            >
                              <S.NotesContentCell>
                                {auditPoint.auditPointNo}
                              </S.NotesContentCell>
                              <S.NotesContentCell>
                                {auditPoint.note}
                              </S.NotesContentCell>
                            </tr>
                          ))}
                      </tbody>
                    </S.NotesTable>
                  </S.NotesCell>
                </S.NotesRow>
              )}

              {pledge.auditPoints.filter(
                ap =>
                  ap.checkPoints.filter(cp => cp.notes.length > 0).length > 0
              ).length > 0 && (
                <S.NotesRow>
                  <S.PledgeSpacerCell width='15px' />
                  <S.NotesCell>
                    <S.NotesTable cellPadding={2} cellSpacing={0}>
                      <tbody>
                        <tr>
                          <S.NotesHeaderCell width='100px'>
                            {'Audit Point'}
                          </S.NotesHeaderCell>
                          <S.NotesHeaderCell width='485px'>
                            {'Note'}
                          </S.NotesHeaderCell>
                        </tr>
                        {pledge.auditPoints
                          .filter(ap =>
                            ap.checkPoints.some(cp => cp.notes.length > 0)
                          )
                          .map(auditPoint =>
                            auditPoint.checkPoints
                              .filter(cp => cp.notes.length > 0)
                              .map(checkPoint =>
                                checkPoint.notes.map(note => (
                                  <tr
                                    key={`${auditPoint.id}-${checkPoint.id}-note`}
                                  >
                                    <S.NotesContentCell>
                                      {checkPoint.checkPointNo}
                                    </S.NotesContentCell>
                                    <S.NotesContentCell>
                                      {note}
                                    </S.NotesContentCell>
                                  </tr>
                                ))
                              )
                              .flat()
                          )
                          .flat()}
                      </tbody>
                    </S.NotesTable>
                  </S.NotesCell>
                </S.NotesRow>
              )}
              <S.PledgeSpacerRow>
                <S.PledgeSpacerCell width='15px'>&nbsp;</S.PledgeSpacerCell>
                <S.PledgeSpacerCell width='585px'>&nbsp;</S.PledgeSpacerCell>
              </S.PledgeSpacerRow>
            </>
          ))}
        </tbody>
      </S.PledgesTable>
    )
  }

  const renderSummaryTable = () => {
    const summaryData = auditData.pledges.map(pledge => {
      const mandatoryCount = pledge.auditPoints.filter(
        ap => ap.isMandatory
      ).length
      const mandatoryChecked = pledge.auditPoints.filter(
        ap => ap.isMandatory && ap.isPointCheckedYes
      ).length

      const developmentCount = pledge.auditPoints.filter(
        ap => !ap.isMandatory
      ).length
      const developmentChecked = pledge.auditPoints.filter(
        ap => !ap.isMandatory && ap.isPointCheckedYes
      ).length

      return {
        pledgeId: pledge.pledgeNo,
        description: pledge.translatedDescription,
        mandatory: mandatoryCount,
        mandatoryChecked: mandatoryChecked,
        development: developmentCount,
        developmentChecked: developmentChecked
      }
    })

    return (
      <S.SummaryRow>
        <S.SummaryContentCell colSpan={2}>
          <S.SummaryMainTable>
            <S.SummaryContentRow>
              <S.SummaryContentCell>
                <S.SummaryTable cellPadding={4} cellSpacing={0}>
                  <thead>
                    <S.SummaryHeaderRow>
                      <S.SummaryHeaderCell width='60px'>
                        &nbsp;
                      </S.SummaryHeaderCell>
                      <S.SummaryHeaderCell>&nbsp;</S.SummaryHeaderCell>
                      <S.SummaryHeaderCell width='60px'>
                        Man.
                      </S.SummaryHeaderCell>
                      <S.SummaryHeaderCell width='60px'>
                        Dev.
                      </S.SummaryHeaderCell>
                    </S.SummaryHeaderRow>
                  </thead>
                  <tbody>
                    {summaryData.map((summary, index) => (
                      <S.SummaryDataRow
                        key={summary.pledgeId}
                        isEven={index % 2 === 0}
                      >
                        <S.SummaryDataCell width='60px'>
                          {summary.pledgeId}
                        </S.SummaryDataCell>
                        <S.SummaryDataCell textAlign='left'>
                          {parse(summary.description)}
                        </S.SummaryDataCell>
                        <S.SummaryDataCell width='60px'>
                          {`${summary.mandatoryChecked} / ${summary.mandatory}`}
                        </S.SummaryDataCell>
                        <S.SummaryDataCell width='60px'>
                          {`${summary.developmentChecked} / ${summary.development}`}
                        </S.SummaryDataCell>
                      </S.SummaryDataRow>
                    ))}
                  </tbody>
                  <tfoot>
                    <S.SummaryFooterRow>
                      <S.SummaryFooterCell>&nbsp;</S.SummaryFooterCell>
                      <S.SummaryFooterCell>
                        {`Result: `}
                        <br />
                        <br />
                        {` Required Poiints:`}
                      </S.SummaryFooterCell>
                      <S.SummaryFooterCell textAlign='center'>
                        {`${summaryData.reduce(
                          (acc, s) => acc + s.mandatoryChecked,
                          0
                        )}`}
                        <br />
                        <br />
                        {`${summaryData.reduce(
                          (acc, s) => acc + s.mandatory,
                          0
                        )}`}
                      </S.SummaryFooterCell>
                      <S.SummaryFooterCell textAlign='center'>
                        {`${summaryData.reduce(
                          (acc, s) => acc + s.developmentChecked,
                          0
                        )}`}
                        <br />
                        <br />
                        {`${summaryData.reduce(
                          (acc, s) => acc + s.development,
                          0
                        )}`}
                      </S.SummaryFooterCell>
                    </S.SummaryFooterRow>
                  </tfoot>
                </S.SummaryTable>
              </S.SummaryContentCell>
            </S.SummaryContentRow>
            <S.SummaryCommentsRow>
              <S.SummaryCommentsCell>
                <span className='lblStyleHeader'>Audit Comments</span>
                <br />
                <span className='lblStyleBox'>
                  {auditData.auditNote || '\u00A0'}
                </span>
              </S.SummaryCommentsCell>
            </S.SummaryCommentsRow>
          </S.SummaryMainTable>
        </S.SummaryContentCell>
      </S.SummaryRow>
    )
  }

  return (
    <html lang='en'>
      <head>
        <meta charSet='UTF-8' />
        <meta name='viewport' content='width=device-width, initial-scale=1.0' />
        <title>QPR Report Printout</title>
        <style>{S.GlobalStyles}</style>
      </head>
      <S.PrintContainer>
        <S.MainTable>
          <tr>
            <S.SpacerCell>&nbsp;</S.SpacerCell>
          </tr>
          <tr>
            <S.MainContentCell>
              <S.ControlsSection className='noPrint'>
                <S.PrintButton
                  type='button'
                  value='Print'
                  onClick={() => {
                    window.print()
                  }}
                />
                <S.PrintButton
                  type='button'
                  value='Close'
                  onClick={() => window.close()}
                />
                <br />
                <br />
                <S.CheckboxLabel>
                  <input
                    type='checkbox'
                    placeholder='View CheckPoints'
                    checked={printOptions.viewCheckPoints}
                    onChange={e => {
                      const newUrl = new URL(window.location.href)
                      newUrl.searchParams.set(
                        'viewCheckPoints',
                        e.target.checked.toString()
                      )
                      navigate(`${newUrl.pathname}${newUrl.search}`)
                    }}
                  />
                  View CheckPoints
                </S.CheckboxLabel>
                <S.CheckboxLabel>
                  <input
                    type='checkbox'
                    placeholder='View Summary'
                    checked={printOptions.viewSummary}
                    onChange={e => {
                      const newUrl = new URL(window.location.href)
                      newUrl.searchParams.set(
                        'viewSummary',
                        e.target.checked.toString()
                      )
                      navigate(`${newUrl.pathname}${newUrl.search}`)
                    }}
                  />
                  View Summary
                </S.CheckboxLabel>
                <S.CheckboxLabel>
                  <input
                    type='checkbox'
                    placeholder='View Perspectives'
                    checked={printOptions.viewPerspectives}
                    onChange={e => {
                      const newUrl = new URL(window.location.href)
                      newUrl.searchParams.set(
                        'viewPerspectives',
                        e.target.checked.toString()
                      )
                      navigate(`${newUrl.pathname}${newUrl.search}`)
                    }}
                  />
                  View Perspectives
                </S.CheckboxLabel>
              </S.ControlsSection>

              <br />

              <S.PrintDiv id='printDiv'>
                <div>
                  <S.ContentTable className='content-table'>
                    <tr>
                      <S.LogoCell align='left'>
                        <S.ScaniaLogo
                          className='footer-logo-dark'
                          src='/assets/scania-wordmark.png'
                          alt='Scania Logo'
                        />
                      </S.LogoCell>
                      <td align='right'>
                        <S.ScaniaIcon
                          className='header-info-icon'
                          src='/assets/scania-symbol.png'
                          alt='Info Icon'
                        />
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={2}>&nbsp;</td>
                    </tr>
                    <tr>
                      <td colSpan={2} align='center'>
                        <span className='LabelHeader'>
                          {`Scania Dealer Operating Standards ${auditData.dosVersion}`}
                        </span>
                        <br />
                        <span className='LabelSubHeader'>
                          {`Quality Profile Report`}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={2}>
                        <S.HrSeparator className='hr-separator' />
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={2}>
                        <S.InfoTable className='info-table'>
                          <tr>
                            <td align='right' width='100px'>
                              <span className='mini'>Dealer Name:</span>
                            </td>
                            <S.InfoValueCell align='left' width='175px'>
                              <span className='mini'>
                                {auditData.dealerName || '\u00A0'}
                              </span>
                            </S.InfoValueCell>
                            <S.InfoSpacerCell width='50px'></S.InfoSpacerCell>
                            <td align='right' width='100px'>
                              <span className='mini'>Audit Date:</span>
                            </td>
                            <S.InfoValueCell align='left' width='175px'>
                              <span className='mini'>
                                {formatDate(auditData.auditDate) || '\u00A0'}
                              </span>
                            </S.InfoValueCell>
                          </tr>
                          <tr>
                            <td align='right' width='100px'>
                              <span className='mini'>Dealer ID:</span>
                            </td>
                            <S.InfoValueCell align='left' width='175px'>
                              <span className='mini'>
                                {auditData.dealerId || '\u00A0'}
                              </span>
                            </S.InfoValueCell>
                            <S.InfoSpacerCell width='50px'></S.InfoSpacerCell>
                            <td align='right' width='100px'>
                              <span className='mini'>Auditor(s):</span>
                            </td>
                            <S.InfoValueCell align='left' width='175px'>
                              <span className='mini'>
                                {auditData.auditors || '\u00A0'}
                              </span>
                            </S.InfoValueCell>
                          </tr>
                          <tr>
                            <td align='right' width='100px'>
                              <span className='mini'>City:</span>
                            </td>
                            <S.InfoValueCell align='left' width='175px'>
                              <span className='mini'>
                                {auditData.city || '\u00A0'}
                              </span>
                            </S.InfoValueCell>
                            <S.InfoSpacerCell width='50px'></S.InfoSpacerCell>
                            <td align='right' width='100px'>
                              <span className='mini'>Country:</span>
                            </td>
                            <S.InfoValueCell align='left' width='175px'>
                              <span className='mini'>
                                {auditData.country || '\u00A0'}
                              </span>
                            </S.InfoValueCell>
                          </tr>
                          {auditData.certificateValidity && (
                            <tr>
                              <td align='right' width='100px'>
                                <span className='mini'>
                                  Certificate Validity:
                                </span>
                              </td>
                              <S.InfoValueCell align='left' width='175px'>
                                <span className='mini'>
                                  {auditData.certificateValidity}
                                </span>
                              </S.InfoValueCell>
                              <S.InfoSpacerCell width='50px'></S.InfoSpacerCell>
                              <td align='right' width='100px'>
                                <span className='mini'>
                                  Certificate Expiry Date:
                                </span>
                              </td>
                              <S.InfoValueCell align='left' width='175px'>
                                <span className='mini'>
                                  {auditData.certificateExpiryDate
                                    ? formatDate(
                                        auditData.certificateExpiryDate
                                      )
                                    : '\u00A0'}
                                </span>
                              </S.InfoValueCell>
                            </tr>
                          )}
                        </S.InfoTable>
                      </td>
                    </tr>

                    {printOptions.viewSummary && renderSummaryTable()}

                    <tr>
                      <td colSpan={2} width='600px' valign='top'>
                        {renderPledges()}
                      </td>
                    </tr>
                  </S.ContentTable>
                </div>
              </S.PrintDiv>
              <br />
            </S.MainContentCell>
          </tr>
        </S.MainTable>
      </S.PrintContainer>
    </html>
  )
}
